import gtmDataLayer from './gtmDataLayer';

// this should only typically be used when adding tracking
// to the dataLayer before firing the pageview
export function addGTMMessage(message: ObjectType): void {
    gtmDataLayer.push(message);
}
